import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Pillars } from './components/Pillars';
import { Pricing } from './components/Pricing';
import { About } from './components/About';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark selection:bg-brand-purple/30 selection:text-brand-pink" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Pillars data-id="element-4" />
        <Pricing data-id="element-5" />
        <About data-id="element-6" />
      </main>

      <Footer data-id="element-7" />
    </div>;
}